/* prettier-ignore */
import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { legacyInformerRedirect } from '../helpers/tech-mode-entry';
import { InformerModeEntryService } from '../services/informer-mode-entry.service';

/**
 * HRS-3145: `?techMode=true` e `?informer=<modo>` siguen valiendo (hay QR
 * impresos con esa URL), pero ahora redirigen a `/tech-mode/...`, que es quien
 * activa el modo. Va como `canActivateChild` de la raíz porque el param puede
 * llegar sobre cualquier ruta.
 *
 * Tiene que correr en el router y no en `AppComponent.ngOnInit`: el `tick()`
 * inicial (y con él `initializeParams`) ocurre antes de `initialNavigation()`,
 * así que si allí se borrasen estos params de la URL el router nunca los vería.
 */
export const legacyInformerParamsGuard: CanActivateChildFn = (_child, state) => {
  const redirect = legacyInformerRedirect(state.url);
  if (!redirect)
    return true;

  if (redirect.enter)
    inject(InformerModeEntryService).enter(redirect.enter.mode, redirect.enter.registerId);

  return inject(Router).parseUrl(redirect.target);
};
